module.exports = __webpack_public_path__ + "static/autocheck-icon-fb724f62c47af4bbff8538a33e3c096f.png";